import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/common/PrivateRoute';
import AppLayout from './components/layout/AppLayout';
import Login from './pages/auth/Login';
import Dashboard from './pages/dashboard/Dashboard';
import Funcionarios from './pages/funcionarios/Funcionarios';
import FuncionarioNovo from './pages/funcionarios/FuncionarioNovo';
import FuncionarioEdit from './pages/funcionarios/FuncionarioEdit';
import FuncionarioDetalhe from './pages/funcionarios/FuncionarioDetalhe';
import FitTests from './pages/fit_tests/FitTests';
import FitTestNovo from './pages/fit_tests/FitTestNovo';
import SolicitarAgendamento from './pages/fit_tests/SolicitarAgendamento';
import Agenda from './pages/fit_tests/Agenda';
import Equipamentos from './pages/equipamentos/Equipamentos';
import Empresas from './pages/empresas/Empresas';
import Usuarios from './pages/usuarios/Usuarios';
import Locais from './pages/locais/Locais';
import MeuPerfil from './pages/perfil/MeuPerfil';
import Auditoria from './pages/auditoria/Auditoria';
import AgendaDetalhe from './pages/fit_tests/AgendaDetalhe';
import './styles/global.css';

function PrivateLayout({ children, perfil }) {
  return (
    <PrivateRoute perfil={perfil}>
      <AppLayout>{children}</AppLayout>
    </PrivateRoute>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<PrivateLayout><Dashboard /></PrivateLayout>} />
          <Route path="/funcionarios" element={<PrivateLayout><Funcionarios /></PrivateLayout>} />
          <Route path="/funcionarios/novo" element={<PrivateLayout><FuncionarioNovo /></PrivateLayout>} />
          <Route path="/funcionarios/:id/editar" element={<PrivateLayout perfil="fenix"><FuncionarioEdit /></PrivateLayout>} />
          <Route path="/funcionarios/:id" element={<PrivateLayout><FuncionarioDetalhe /></PrivateLayout>} />
          <Route path="/fit-tests" element={<PrivateLayout><FitTests /></PrivateLayout>} />
          <Route path="/fit-tests/novo" element={<PrivateLayout perfil="fenix"><FitTestNovo /></PrivateLayout>} />
          <Route path="/solicitar-agendamento" element={<PrivateLayout><SolicitarAgendamento /></PrivateLayout>} />
          <Route path="/agenda" element={<PrivateLayout><Agenda /></PrivateLayout>} />
          <Route path="/agenda/detalhe" element={<PrivateLayout perfil="fenix"><AgendaDetalhe /></PrivateLayout>} />
          <Route path="/equipamentos" element={<PrivateLayout perfil="fenix"><Equipamentos /></PrivateLayout>} />
          <Route path="/empresas" element={<PrivateLayout perfil="fenix"><Empresas /></PrivateLayout>} />
          <Route path="/usuarios" element={<PrivateLayout perfil="fenix"><Usuarios /></PrivateLayout>} />
          <Route path="/locais" element={<PrivateLayout><Locais /></PrivateLayout>} />
          <Route path="/meu-perfil" element={<PrivateLayout><MeuPerfil /></PrivateLayout>} />
          <Route path="/auditoria" element={<PrivateLayout perfil="admin"><Auditoria /></PrivateLayout>} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
